import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { QuotationInfo } from 'src/app/core/models/quotations-info.model';
import { Quote } from 'src/app/core/models/quote.model';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { RestService } from 'src/app/core/services/rest.service';
import { ComparePremiumComponent } from 'src/app/shared/components/compare-premium/compare-premium.component';
import { NotificationComponent } from 'src/app/shared/components/notification/notification.component';

@Component({
  selector: 'app-quotation-premium',
  templateUrl: './quotation-premium.component.html',
  styleUrls: ['./quotation-premium.component.scss']
})
export class QuotationPremiumComponent {
  dataSource!: MatTableDataSource<Quote>;
  columnsToDisplay = ['Position', 'ProductName', 'sTotalAmount', 'action'];
  quotationId: string = '';
  quotesInfo!: QuotationInfo;
  isLoadingForQuotesList = true;
  quotesList: any[] = [];
  // quotesList: Quote[] = [];
  quotationPremium: any = {
    productDetailes: [],
    coverages: []
  }
  premiumBreakdown:any=
    {
      "numInsured": 1,
      "individualPricing": 1,
      "mandatoryCoverage": 1317.00,
      "startPrice": 1317.00,
      "webDiscount": 0.00,
      "SurchargesDiscount_PerInsured": -658.50,
      "detail_SurchargesDiscount_PerInsured": {
        "SurchargeDiscount": {
          "idRegCriteria": "1",
          "criteria": "Age",
          "calculatedValue": -658.50
        }
      }
    };
  
  constructor(
    private restService: RestService,
    private loader: LoaderService,
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private errorHandler: ErrorHandlerService,
  ) {
    this.route.params.subscribe(params => {
      this.quotationId = params['quotationId'];
    });
  }

  ngOnInit() {
    this.GetQuotesInfo();
  }

  GetQuotesInfo() {
    let params = {
      QuotationID: this.quotationId
    }
    this.loader.show();
    this.restService.postData(params, 'api/Quotation/GetB2CQuotesInfo').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.quotesInfo = data.rObj.GetQuotesInfo;
              let getQuotes = data.rObj.GetQuotes || [];
              let premiumBreaks = data.rObj.premiumBreaks || [];
              this.quotesList=this.mapPremiumBreaksToQuotes(getQuotes,premiumBreaks);
              
              this.isLoadingForQuotesList = false;
              this.quotesList = this.quotesList.map((quote: any, index: any) => ({
                ...quote,
                Position: index + 1,
                CoverageList: quote.CoverageTitle ? quote.CoverageDescription.split(',') : []
              }));

              let allCoverageItems = this.quotesList.flatMap((quote: any) => quote.CoverageList);
              let distinctCoverageItems = Array.from(new Set(allCoverageItems));

              this.quotationPremium.productDetailes = this.quotesList;
              this.quotationPremium.coverages = distinctCoverageItems;

              this.dataSource = new MatTableDataSource(this.quotesList);
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.isLoadingForQuotesList = false;
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }
   mapPremiumBreaksToQuotes(quotesData:any, premiumBreaks:any) {
    quotesData.forEach((quote:any) => {
      quote.PremiumBreaks = premiumBreaks
          .filter((breakData:any) => breakData.QuotesID === quote.QuotesID)
          .sort((a:any, b:any) => a.Sequence - b.Sequence);
  });

  return quotesData;
}
  DownloadQuotation() {
    let params = {
      QuotationID: this.quotationId
    }
    this.loader.show();
    this.restService.postData(params, 'api/Download/DownloadB2CQuotation').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              if (data.rObj.URL) {
                window.open(data.rObj.URL, '_target');
              }

            }
            else if (data.rcode == 2) {
              let _dialogRef = this.dialog.open(NotificationComponent, {
                disableClose: true,
                width: '75vw',
                panelClass: 'dialog-class',
                data: {
                  block: 'downloadQuotationProgress'
                }
              });

              _dialogRef.afterClosed().subscribe(result => {
                if (result) {

                }
              });
            }
            else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  goBack() {
    history.back();
  }

  editQuotation() {
    this.router.navigate(['quotation/get-quote', this.quotationId]);
  }

  BackToGetQuote() {
    this.router.navigate(['quotation/get-quote', this.quotationId]);
  }

  comparePremiumNewPage() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['quotation/compare-product', this.quotationId])
    );
    window.open(url, '_blank');
  }
  comparePremium() {
    let _dialogRef = this.dialog.open(ComparePremiumComponent, {
      disableClose: true,
      width: '100vw',
      panelClass: 'dialog-class',
      data: {
        quotationId: this.quotationId
      }
    });

    _dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }

  BuyPolicy(productID: string | undefined,) {
    this.router.navigate(['quotation/proposal-form', this.quotationId, productID]);
  }
}
